import React from 'react';
import { useAuth } from '../App';

const PartnerBenefitsShowcase = () => {
  const { language } = useAuth();

  return (
    <div style={{ marginBottom: '2.5rem', borderRadius: '16px', overflow: 'hidden', backgroundColor: '#fbf7ec', border: '1px solid #d6c8a3', boxShadow: '0 12px 35px rgba(40,28,8,0.15)' }}>
      {/* Hero Section */}
      <div style={{ 
        position: 'relative', 
        padding: '3rem 2rem', 
        background: 'radial-gradient(circle at 80% -8%, rgba(189,134,38,0.16) 16%, transparent 60%), radial-gradient(circle at 6% 4%, rgba(14,82,51,0.12) 12%, transparent 55%), #0e5233',
        color: '#f3ecd8',
        textAlign: 'center'
      }}>
        <div style={{ 
          display: 'inline-flex', alignItems: 'center', gap: '9px', marginBottom: '16px', 
          fontSize: '0.75rem', letterSpacing: '0.22em', textTransform: 'uppercase', color: '#d8ad57', fontWeight: '700' 
        }}>
          <span style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#8a2012' }}></span>
          Mutual Benefit Platform
        </div>
        <h1 style={{ 
          fontFamily: '"Iowan Old Style", "Palatino Linotype", Palatino, Georgia, serif', 
          fontSize: 'clamp(2rem, 4vw, 3rem)', 
          fontWeight: '600', 
          lineHeight: '1.2', 
          margin: '0 0 1rem 0',
          color: '#ffffff'
        }}>
          <span style={{ display: 'block', color: '#4bbd85', fontSize: 'clamp(1.5rem, 3vw, 2rem)', marginBottom: '0.5rem' }}>
            {language === 'en' ? 'Ahobilam Seva Profiles' : 'அஹோபிலம் சேவா ப்ரொஃபைல்'}
          </span>
          {language === 'en' ? 'Your divine service deserves a global identity.' : 'உங்கள் சிறப்பான இறைச்சேவை உலகம் முழுவதும் சென்றடைய வேண்டும்.'}
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#d6c8a3', maxWidth: '650px', margin: '0 auto', lineHeight: '1.6' }}>
          {language === 'en' 
            ? "As an independent Vadhyar, Cook, or Pandit, your success relies on word-of-mouth. Transform your local reputation into a permanent, verifiable digital profile in the world's largest Sri Vaishnava network."
            : 'சுயாதீனமாகச் செயல்படும் வாத்தியார், சமையல் சுவாமிகள் அல்லது பண்டிதர்களின் வெற்றி, மற்றவர்கள் அவர்களைப் பற்றிச் சொல்வதை மட்டுமே நம்பியுள்ளது. உங்கள் திறமையை நிரந்தர டிஜிட்டல் அடையாளமாக மாற்றுங்கள்.'}
        </p>
      </div>

      {/* Features Grid */}
      <div style={{ padding: '3rem 2rem', backgroundColor: '#fbf7ec' }}>
        <h2 style={{ textAlign: 'center', fontFamily: '"Iowan Old Style", Palatino, serif', fontSize: '2rem', color: '#8a2012', marginBottom: '2rem' }}>
          {language === 'en' ? 'Working as a community is infinitely more powerful.' : 'தனித்துச் செயல்படுவதை விட சமூகமாகச் செயல்படுவது சக்தி வாய்ந்தது'}
        </h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem', maxWidth: '1000px', margin: '0 auto' }}>
          
          {/* Feature 1 */}
          <div style={{ background: '#ffffff', border: '1px solid #d6c8a3', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', boxShadow: '0 4px 10px rgba(40,28,8,0.05)' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>📜</div>
            <h3 style={{ fontFamily: '"Iowan Old Style", Palatino, serif', fontSize: '1.25rem', color: '#0e5233', marginBottom: '0.75rem' }}>
              {language === 'en' ? 'Showcase Your Journey' : 'உங்கள் சிறப்பம்சங்கள்'}
            </h3>
            <p style={{ color: '#6b5c40', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
              {language === 'en' ? 'Post your authentic Vedic qualifications, traditional awards, and honors. Build instant trust with customers who can verify your expertise.' : 'உங்கள் சிறப்புகள், பாரம்பரிய விருதுகள் மற்றும் தகுதிகளைப் பதிவு செய்யுங்கள். இது வாடிக்கையாளர்களிடம் நம்பிக்கையை ஏற்படுத்தும்.'}
            </p>
          </div>

          {/* Feature 2 */}
          <div style={{ background: '#ffffff', border: '1px solid #d6c8a3', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', boxShadow: '0 4px 10px rgba(40,28,8,0.05)' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>📸</div>
            <h3 style={{ fontFamily: '"Iowan Old Style", Palatino, serif', fontSize: '1.25rem', color: '#0e5233', marginBottom: '0.75rem' }}>
              {language === 'en' ? 'A Collection of Memories' : 'நினைவுகளின் தொகுப்பு'}
            </h3>
            <p style={{ color: '#6b5c40', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
              {language === 'en' ? 'Your profile becomes a living portfolio. Let your profile grow day-by-day with memories and photos of the successful homams and marriages you conduct.' : 'நீங்கள் நடத்திய வெற்றிகரமான ஹோமங்கள், திருமணங்கள் மற்றும் நிகழ்வுகளின் நினைவுகளைப் பதிவு செய்து உங்கள் ப்ரொஃபைலை வளர்க்கவும்.'}
            </p>
          </div>

          {/* Feature 3 */}
          <div style={{ background: '#ffffff', border: '1px solid #d6c8a3', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', boxShadow: '0 4px 10px rgba(40,28,8,0.05)' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>🤝</div>
            <h3 style={{ fontFamily: '"Iowan Old Style", Palatino, serif', fontSize: '1.25rem', color: '#0e5233', marginBottom: '0.75rem' }}>
              {language === 'en' ? 'Mutual Benefit' : 'பரஸ்பர நலன்'}
            </h3>
            <p style={{ color: '#6b5c40', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
              {language === 'en' ? 'You are never alone. Need a cook for a massive wedding? Find one instantly. Need an extra assistant for a complex Aparam? The network is here for you.' : 'உங்களுக்கு உதவியாக மற்றவர்களையும் இங்கே எளிதாகக் கண்டறியலாம். பெரிய கல்யாணத்திற்கு சமையல் ஆட்கள் தேவையென்றாலும் உடனடியாகக் கிடைக்கும்.'}
            </p>
          </div>

        </div>
      </div>

      {/* Volunteer Ribbon */}
      <div style={{ background: '#8a2012', color: '#f3ecd8', padding: '1rem 2rem', textAlign: 'center', fontSize: '1rem' }}>
        <strong>{language === 'en' ? 'Not offering a service?' : 'நீங்கள் சேவை வழங்குபவர் இல்லையா?'}</strong> {language === 'en' ? 'Join as a Volunteer Guide to recommend trusted providers to those in need.' : 'அப்படியென்றால் ஒரு சமூக வழிகாட்டியாக (Volunteer Guide) இணைந்து மற்றவர்களுக்கு உதவுங்கள்.'}
      </div>
    </div>
  );
};

export default PartnerBenefitsShowcase;

